import api from '@/api';
import {
  ItemServiceListRequest,
  ItemServiceListResponse,
} from './ItemService.types';
import { API_BASE_URL } from '..';

const CONTROLLER = `${API_BASE_URL}/ItemService`;

export default {
  async list(params: ItemServiceListRequest) {
    const result = (await api.get(CONTROLLER, params)) as unknown;

    return result as ItemServiceListResponse;
  },
};
